export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const TOKEN = 'TOKEN'
export const REDIRECT = 'REDIRECT'
export const NBUSERS = 'NBUSERS'
export const UPDATE_USER = 'UPDATE_USER'
export const SET_CAPTCHA_KEY = 'SET_CAPTCHA_KEY'

export const SET_EXPLOITATIONS = 'SET_EXPLOITATIONS'
export const DEL_EXPLOITATION = 'DEL_EXPLOITATION'
export const SET_INFORMATION = 'SET_INFORMATION'

export const SET_ILOTS = 'SET_ILOTS'
export const ADD_ILOT = 'ADD_ILOT'
export const SET_ILOT = 'SET_ILOT'
export const REMOVE_ILOT = 'REMOVE_ILOT'
export const SET_CURRENT_ILOT = 'SET_CURRENT_ILOT'

export const SET_SOL_ILOT = 'SET_SOL_ILOT'
export const SET_SOL_ILOTS = 'SET_SOL_ILOTS'

export const SET_CULTURES = 'SET_CULTURES'
export const ADD_CULTURE = 'ADD_CULTURE'
export const SET_CULTURE = 'SET_CULTURE'
export const REMOVE_CULTURE = 'REMOVE_CULTURE'
export const SET_CURRENT_CULTURE = 'SET_CURRENT_CULTURE'

export const SET_SOL_CULTURE = 'SET_SOL_CULTURE'
export const SET_SOL_CULTURES = 'SET_SOL_CULTURES'

export const SET_STADE_CULTURE = 'SET_STADE_CULTURE'
export const SET_STADE_CULTURES = 'SET_STADE_CULTURES'

export const SET_SIMULATIONS = 'SET_SIMULATIONS'
export const SET_SIMULATION = 'SET_SIMULATION'
export const SET_ANNEES_SECHES = 'SET_ANNEES_SECHES'
export const SET_SIMU_CLIM = 'SET_SIMU_CLIM'
export const SET_SIMULATION_PARCELLES = 'SET_SIMULATION_PARCELLES'
export const ADD_SIMULATION = 'ADD_SIMULATION'
export const DEL_SIMULATION = 'DEL_SIMULATION'
export const ADD_SIMULATION_SCENARIO = 'ADD_SIMULATION_SCENARIO'
export const UPDATE_SIMULATION_SCENARIO = 'UPDATE_SIMULATION_SCENARIO'
export const DEL_SIMULATION_SCENARIO = 'DEL_SIMULATION_SCENARIO'
export const UPDATE_SYNTHESE = 'UPDATE_SYNTHESE'
export const UPDATE_SIMULATION_CLIMATIQUE = 'UPDATE_SIMULATION_CLIMATIQUE'
export const UPDATE_SIMULATION_NAME = 'UPDATE_SIMULATION_NAME'
export const SET_HAS_RESULTAT = 'SET_HAS_RESULTAT'

export const SET_FILTRE_ANNEE = 'SET_FILTRE_ANNEE'
export const SET_FILTRE_ILOT = 'SET_FILTRE_ILOT'
export const SET_FILTRE_CULTURE = 'SET_FILTRE_CULTURE'

export const ADD_LOADING_MESSAGES = 'ADD_LOADING_MESSAGES'
export const DEL_LOADING_MESSAGES = 'DEL_LOADING_MESSAGES'

export const ADD_TOAST = 'ADD_TOAST'
export const DEL_TOAST = 'DEL_TOAST'
